package one.healthium.log_food.ui.add_food

import androidx.compose.material3.Surface
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import one.healthium.profile.ui.food.components.FoodEditComponent
import one.healthium.profile.ui.food.models.AmountUiModel
import one.healthium.profile.ui.food.models.FoodUiModel
import one.healthium.profile.ui.food.models.FoodUiOptions
import one.healthium.rateus.data.ShowAppRateForFoodLog
import one.healthium.ui.common.message.AlertUiMessageHandler
import one.healthium.ui.compose.theme.AppTheme
import androidx.compose.ui.tooling.preview.Preview
import org.koin.compose.viewmodel.koinViewModel
import kotlin.time.Instant

interface AddFoodEventDelegate {
    fun onFoodAdded()
}

@Composable
internal fun AddFoodScreen(
    food: FoodUiModel,
    eventDelegate: AddFoodEventDelegate,
    taskId: String? = null,
) {
    val viewModel = koinViewModel<AddFoodViewModel>()
    val state by viewModel.state.collectAsState()
    var shouldRateApp by remember { mutableStateOf(false) }

    LaunchedEffect(food) {
        viewModel.onFoodChanged(food)
    }

    LaunchedEffect(state.foodAdded) {
        if (state.foodAdded) {
            shouldRateApp = true
        }
    }

    if (shouldRateApp) {
        ShowAppRateForFoodLog(onDismissRequest = eventDelegate::onFoodAdded)
    }

    AddFoodContent(
        state = state,
        onAddClicked = { options -> viewModel.onAddClicked(options, taskId) },
        onAmountChanged = viewModel::onAmountChanged,
        onTimeChanged = viewModel::onTimeChanged,
    )

    AlertUiMessageHandler(viewModel.uiMessage)
}

@Composable
internal fun AddFoodContent(
    state: AddFoodUiState,
    onAddClicked: (FoodUiOptions) -> Unit,
    onAmountChanged: (AmountUiModel) -> Unit,
    onTimeChanged: (Instant) -> Unit,
) {
    FoodEditComponent(
        food = state.options,
        amount = state.currentAmount,
        selectedDate = state.selectedDate,
        actionText = "Add",
        loading = state.loading,
        onActionClicked = onAddClicked,
        onAmountChanged = onAmountChanged,
        onTimeChanged = onTimeChanged,
    )
}

@Composable
@Preview
private fun AddFoodContentPreview() {
    AppTheme {
        Surface {
            AddFoodContent(
                state = AddFoodUiState(
                    currentAmount = AmountUiModel.preview,
                    loading = false,
                    foodAdded = false,
                    currentFood = FoodUiModel.preview,
                ),
                onAddClicked = {},
                onAmountChanged = {},
                onTimeChanged = {}
            )
        }
    }
}
